'use client';

import Image from 'next/image';
import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FeatureHero from '../_shared/sections/FeatureHero';

type Props = { lang: Locale };

const SIGNUP_FORM_IMAGE = 'https://cdn.1cdn.app/application/UMD/26050412170724_signup-form.png';

const SignupFormsHero = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const visual = (
    <Image
      src={SIGNUP_FORM_IMAGE}
      alt={t('SignupForms/Hero/visual_alt')}
      width={840}
      height={840}
      sizes="(min-width: 1024px) 320px, 70vw"
      className="mx-auto h-auto w-3/4 max-w-[320px] rounded-3xl lg:w-full"
      priority
    />
  );

  return (
    <FeatureHero
      accent="#22D3EE"
      ariaLabel={t('SignupForms/Hero/aria_label')}
      copy={{
        kicker: t('SignupForms/Hero/badge'),
        headlineA: t('SignupForms/Hero/title1'),
        headlineB: t('SignupForms/Hero/title2'),
        subhead: t('SignupForms/Hero/subtitle'),
        ctaPrimary: {
          label: t('SignupForms/Hero/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('SignupForms/Hero/cta_secondary'),
          href: '#how-it-works',
        },
      }}
      visual={visual}
      visualVisibleOnMobile
    />
  );
};

export default SignupFormsHero;
